import styled from 'styled-components';

interface StyledDataEntryFormSubmitButtonProps {
  $backgroundColor: string;
}

const StyledDataEntryFormSubmitButton = styled.button<StyledDataEntryFormSubmitButtonProps>`
  padding: 13px 50px;
  cursor: pointer;
  background: ${(props) => props.$backgroundColor};
  color: #fff;
  font-size: 16px;
  border: none;
  border-radius: 23px;
  max-width: 200px;
  margin: 0 auto 24px auto;
`;

export default StyledDataEntryFormSubmitButton;